import styled from 'styled-components';

export const DeleteSection = styled.div.attrs({ className: 'sub_title' })`
  margin-top: 15px;
  border-radius: 5px;
  padding: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: ${({ theme }) => theme.white.a10};
  color: ${({ theme }) => theme.red.a10};
`;
